module.exports = __webpack_public_path__ + "img/earth.57accd41.svg";